/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  PMSMappingForAccommodation,
  PMSMappingForChannel,
  PMSMappingRatePlanInput,
  PMSMappingWithRatePlanInput,
  RatePlanDeatials,
  RatePlanForPMSMappingList,
  RoomTypeForPMSMappingList
} from '../../types/accommodationPMSMapping'
import RoomTypeItemBox from './RoomTypeItemBox'
import RoomTypeItemBoxSkeleton from './RoomTypeItemBox.skeleton'
import useStyles from './styles/RoomTypesList.styles'

interface RoomTypesListProps {
  EditModal: any
  roomTypes: RoomTypeForPMSMappingList[] | undefined
  searchInput: string
  channelIndex?: number
  loading: boolean
  haveSuppurtRatePlans: boolean
  customizedForChannel?: boolean
  PMSMappingForAccommodationInput?: PMSMappingForAccommodation
  setPMSMappingForAccommodationInput?: React.Dispatch<
    React.SetStateAction<PMSMappingForAccommodation>
  >
  PMSMappingForChannelInputs?: PMSMappingForChannel[]
  setPMSMappingForChannelInputs?: React.Dispatch<
    React.SetStateAction<PMSMappingForChannel[]>
  >
  channelCode?: string
}

const RoomTypesList: React.FC<RoomTypesListProps> = ({
  EditModal,
  roomTypes,
  searchInput,
  loading,
  haveSuppurtRatePlans,
  customizedForChannel,
  PMSMappingForAccommodationInput,
  setPMSMappingForAccommodationInput,
  PMSMappingForChannelInputs,
  setPMSMappingForChannelInputs,
  channelCode
}) => {
  const classes = useStyles()

  const onChangePMSCodeInput = (AdotelCode: string, newPMSCode: string) => {
    if (customizedForChannel) {
      if (PMSMappingForChannelInputs && PMSMappingForChannelInputs.length > 0) {
        setPMSMappingForChannelInputs?.((prev) =>
          prev.map((channelInput) => {
            if (channelInput.channelCode !== channelCode) return channelInput

            const updatedRoomTypes = channelInput.roomTypes.map((room) =>
              room.AdotelCode === AdotelCode
                ? { ...room, PMSCode: newPMSCode }
                : room
            )

            return {
              ...channelInput,
              roomTypes: updatedRoomTypes
            }
          })
        )
      }
    } else {
      if (PMSMappingForAccommodationInput) {
        const roomTypeIndex =
          PMSMappingForAccommodationInput.roomTypes.findIndex(
            (room) => room.AdotelCode === AdotelCode
          )

        if (roomTypeIndex !== -1) {
          setPMSMappingForAccommodationInput?.({
            ...PMSMappingForAccommodationInput,
            roomTypes: [
              ...PMSMappingForAccommodationInput.roomTypes.slice(
                0,
                roomTypeIndex
              ),
              {
                ...PMSMappingForAccommodationInput.roomTypes[roomTypeIndex],
                PMSCode: newPMSCode
              },
              ...PMSMappingForAccommodationInput.roomTypes.slice(
                roomTypeIndex + 1
              )
            ]
          })
        }
      }
    }
  }

  const onRatePlansChange = (
    AdotelCode: string,
    rateplans: RatePlanForPMSMappingList[],
    updatedRateplans: RatePlanDeatials[]
  ) => {
    if (customizedForChannel) {
      if (PMSMappingForChannelInputs && PMSMappingForChannelInputs.length > 0) {
        setPMSMappingForChannelInputs?.((prev) =>
          prev.map((channelInput) => {
            if (channelInput.channelCode !== channelCode) return channelInput

            const roomTypeIndex = channelInput.roomTypes.findIndex(
              (room) => room.AdotelCode === AdotelCode
            )

            if (roomTypeIndex === -1) return channelInput

            const newRatePlans: PMSMappingRatePlanInput[] = haveSuppurtRatePlans
              ? rateplans.map((rate) => ({
                  AdotelCode: rate.AdotelCode,
                  PMSCode: rate.PMSCode || ''
                }))
              : (() => {
                  const found = rateplans.find(
                    (rate) => rate.PMSCode === 'NoData'
                  )
                  return found
                    ? [
                        {
                          AdotelCode: found.AdotelCode,
                          PMSCode: found.PMSCode || ''
                        }
                      ]
                    : []
                })()

            const updatedRoomTypes = [
              ...channelInput.roomTypes.slice(0, roomTypeIndex),
              {
                ...channelInput.roomTypes[roomTypeIndex],
                ratePlans: newRatePlans
              },
              ...channelInput.roomTypes.slice(roomTypeIndex + 1)
            ]

            return {
              ...channelInput,
              roomTypes: updatedRoomTypes
            }
          })
        )
      }
    } else {
      if (PMSMappingForAccommodationInput) {
        const roomTypeIndex =
          PMSMappingForAccommodationInput.roomTypes.findIndex(
            (room) => room.AdotelCode === AdotelCode
          )

        if (roomTypeIndex !== -1) {
          if (haveSuppurtRatePlans) {
            const newRatePlans: PMSMappingRatePlanInput[] = rateplans.map(
              (rate) => ({
                AdotelCode: rate.AdotelCode,
                PMSCode: rate.PMSCode || ''
              })
            )

            const updatedRoomType = {
              ...PMSMappingForAccommodationInput.roomTypes[roomTypeIndex],
              ratePlans: newRatePlans
            }

            setPMSMappingForAccommodationInput?.({
              ...PMSMappingForAccommodationInput,
              roomTypes: [
                ...PMSMappingForAccommodationInput.roomTypes.slice(
                  0,
                  roomTypeIndex
                ),
                updatedRoomType,
                ...PMSMappingForAccommodationInput.roomTypes.slice(
                  roomTypeIndex + 1
                )
              ]
            })
          } else {
            const foundRatePlan = rateplans.find(
              (rate) => rate.PMSCode === 'NoData'
            )

            const newRatePlans: PMSMappingRatePlanInput[] = foundRatePlan
              ? [
                  {
                    AdotelCode: foundRatePlan.AdotelCode,
                    PMSCode: foundRatePlan.PMSCode || ''
                  }
                ]
              : []

            const updatedRoomType = {
              ...PMSMappingForAccommodationInput.roomTypes[roomTypeIndex],
              ratePlans: newRatePlans
            }

            setPMSMappingForAccommodationInput?.({
              ...PMSMappingForAccommodationInput,
              roomTypes: [
                ...PMSMappingForAccommodationInput.roomTypes.slice(
                  0,
                  roomTypeIndex
                ),
                updatedRoomType,
                ...PMSMappingForAccommodationInput.roomTypes.slice(
                  roomTypeIndex + 1
                )
              ]
            })
          }
        }
      }
    }
  }

  return (
    <div className={classes.root}>
      <div className={classes.listContainer}>
        {loading
          ? Array(6)
              .fill('')
              .map((item, i) => (
                <RoomTypeItemBoxSkeleton
                  key={`roomtypebox-skeleton${item}${i.toString()}`}
                />
              ))
          : roomTypes &&
            roomTypes.map(
              (item, roomTypeIndex) =>
                item.AdotelName.toLocaleLowerCase().includes(
                  searchInput.toLocaleLowerCase()
                ) && (
                  <RoomTypeItemBox
                    key={roomTypeIndex}
                    disabled={!item.Active}
                    roomTypeIndex={roomTypeIndex}
                    loading={loading}
                    data={item}
                    EditModal={EditModal}
                    onChangePMSCodeInput={(AdotelCode, newPMSCode) => {
                      onChangePMSCodeInput(AdotelCode, newPMSCode)
                    }}
                    onRatePlansChange={(
                      AdotelCode: string,
                      rateplans: RatePlanForPMSMappingList[],
                      updatedRateplans: RatePlanDeatials[]
                    ) => {
                      onRatePlansChange(AdotelCode, rateplans, updatedRateplans)
                    }}
                    haveSuppurtRatePlans={haveSuppurtRatePlans}
                    customizedForChannel={customizedForChannel}
                  />
                )
            )}
      </div>
    </div>
  )
}

export default RoomTypesList
